import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from "react";
import TableView from "../../../Basic/TableView";
import { IconDelete, IconEditCustom } from "@sfx/icons";
import { formatUserListData } from "./format";
import { CellName, CellAccess, CellSfxRole } from "../common/cell.component";

var CellSolution = function CellSolution(_ref) {
  var row = _ref.row,
      handleEditOrDetail = _ref.handleEditOrDetail;
  var userInfo = row.original;
  var solution = userInfo.solution;
  return /*#__PURE__*/React.createElement("div", {
    className: "solution-cell"
  }, solution.length, /*#__PURE__*/React.createElement("span", {
    className: "solution-cell-view",
    onClick: function onClick() {
      handleEditOrDetail(_objectSpread(_objectSpread({}, userInfo), {}, {
        modalType: "detail"
      }));
    }
  }, "View"));
};

var CellActions = function CellActions(_ref2) {
  var row = _ref2.row,
      handleEditOrDetail = _ref2.handleEditOrDetail,
      handleDel = _ref2.handleDel,
      currentUserEmail = _ref2.currentUserEmail;
  var userInfo = row.original;
  return /*#__PURE__*/React.createElement("div", {
    className: "cellActions"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleEditOrDetail(_objectSpread(_objectSpread({}, userInfo), {}, {
        modalType: "edit"
      }));
    }
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    size: 18,
    style: {
      marginRight: "17px",
      cursor: "pointer"
    }
  })), userInfo.Email !== currentUserEmail && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleDel(userInfo);
    }
  }, /*#__PURE__*/React.createElement(IconDelete, {
    size: 18,
    style: {
      marginRight: "13px",
      cursor: "pointer"
    }
  })));
};

var UserTable = function UserTable(props) {
  var readOnly = props.readOnly,
      userListData = props.userListData,
      pageIndex = props.pageIndex,
      total = props.total,
      loading = props.loading,
      authUser = props.authUser,
      onSortedChange = props.onSortedChange,
      onChange = props.onChange,
      translate = props.translate,
      handleEditOrDetail = props.handleEditOrDetail,
      handleDel = props.handleDel;
  var columns = useMemo(function () {
    return [{
      id: "UserName",
      show: true,
      isFilterable: false,
      isSortable: true,
      accessor: function accessor(row) {
        return row.userName;
      },
      Header: translate('SFxAccountSettingsUserTableNameTitle'),
      headerStyle: {
        minWidth: 240,
        paddingLeft: "10px"
      },
      style: {
        minWidth: 240,
        paddingLeft: "8px"
      },
      minWidth: 240,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellName, {
          row: row
        });
      }
    }, {
      id: 'LastAccess',
      show: !readOnly,
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: translate('SFxAccountSettingsUserTableLastAccessTitle'),
      headerStyle: {
        minWidth: 250
      },
      style: {
        minWidth: 250
      },
      minWidth: 250,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellAccess, {
          row: row
        });
      }
    }, {
      id: "SolutionsAndRoles",
      show: !readOnly,
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: translate('SFxAccountSettingsUserTableRoleTitle'),
      accessor: function accessor(row) {
        return row.FirstName;
      },
      headerStyle: {
        minWidth: 250
      },
      style: {
        minWidth: 250,
        textAlign: "center"
      },
      minWidth: 250,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellSolution, {
          handleEditOrDetail: handleEditOrDetail,
          row: row
        });
      }
    }, {
      id: "SFxRole",
      show: true,
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: translate('SFxAccountSettingsUserTableSFxRoleTitle'),
      headerStyle: {
        minWidth: 250
      },
      style: {
        minWidth: 250
      },
      minWidth: 250,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellSfxRole, {
          row: row
        });
      }
    }, {
      id: "_actions",
      show: !readOnly,
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      headerStyle: {
        minWidth: 75
      },
      style: {
        minWidth: 75
      },
      minWidth: 75,
      className: "disable-resize",
      headerClassName: "disable-resize",
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellActions, {
          currentUserEmail: authUser.email,
          row: row,
          handleEditOrDetail: handleEditOrDetail,
          handleDel: handleDel
        });
      }
    }];
  }, [readOnly, authUser, handleEditOrDetail, handleDel, translate]);
  return /*#__PURE__*/React.createElement(TableView, {
    columns: columns.filter(function (i) {
      return i.show;
    }),
    data: formatUserListData(userListData),
    pageIndex: pageIndex,
    total: total,
    onSortedChange: onSortedChange,
    onChange: onChange,
    loading: loading
  });
};

export default UserTable;